import { FallbackProps } from 'react-error-boundary';
import React, { ReactElement, useEffect } from 'react';

import MainFrame from 'components/MainFrame';
import { sendError, sendEvent } from 'utils/send';
import { FullPageError } from 'components/FullPageError';
import history from 'configs/history';
import { CriticalError } from './ErrorFallback.utils';
import { IGNORED_MESSAGES } from './ErrorFallback.constant';

function ErrorFallback({
  resetErrorBoundary,
  error,
}: FallbackProps): ReactElement {
  const historyListener = history.listen(() => resetErrorBoundary());

  const criticalError = new CriticalError(error.message);
  criticalError.stack = error.stack;

  if (!IGNORED_MESSAGES.some((msg) => error.message.includes(msg))) {
    sendError(criticalError);
    sendEvent.error();
  }

  useEffect(() => {
    return () => {
      historyListener();
    };
  }, []);

  return (
    <MainFrame>
      <FullPageError
        onClick={resetErrorBoundary}
        message="İşleminizi şu anda gerçekleştiremiyoruz"
        fullPage
      />
    </MainFrame>
  );
}

export { ErrorFallback };
